import request from '@/utils/request'

// 采购单列表
export function fetchList(params) {
    return request({
        url: '/scm/order/list',
        method: 'get',
        params: params
    })
}

// 采购单详情
export function getOrderDetail(id) {
    return request({
        url: `/scm/order/detail?purOrderId=${id}`,
        method: 'get'
    })
}

// 发货
export function deliver(id, data) {
    return request({
        url: `/scm/order/deliver/${id}`,
		method: 'post',
		data
    })
}

// 退货
export function returnOrder(id, data) {
	return request({
		url: `/scm/order/return/${id}`,
		method: 'post',
		data
	})
}

// 物流公司
export function logisticsList() {
	return request({
		url: '/logistics/list',
		method: 'get'
	})
}

// 采购单取消
export function cancelOrder(data) {
	return request({
		url: '/scm/order/cancelOrder',
		method: 'POST',
		data
	})
}

// 下载采购单模板
export function downloadTemplate() {
	return request({
		url: '/scm/order/downloadTemplate',
		method: 'GET',
		responseType: 'blob'
	})
}

// 导入采购单模板
export function importPurOrder(data) {
	return request({
		url: '/scm/order/importPurOrder',
		method: 'POST',
		data
	})
}




// WEBPACK FOOTER //
// ./src/api/pcm/order.js